import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DAMAGE_DURING_ROUTE_STEPS } from './constants'

interface DamageDuringRouteFooterProps {
  activeStep: number
  setActiveStep: (step: number) => void
  isContinueEnabled: boolean
  isBackEnabled?: boolean
  isLoading?: boolean
  onContinue?: () => void
  onSubmit?: () => void
}

export default function DamageDuringRouteFooter({
  activeStep,
  setActiveStep,
  isContinueEnabled,
  isBackEnabled = true,
  isLoading = false,
  onContinue,
  onSubmit,
}: DamageDuringRouteFooterProps) {
  const { t } = useTranslation()
  return (
    <Box display="flex" justifyContent={'space-between'} px={2}>
      <Button
        variant="outlined"
        onClick={() => setActiveStep(activeStep - 1)}
        disabled={activeStep === 0 || !isBackEnabled}
        sx={{
          textTransform: 'none',
        }}
      >
        {t('common.back')}
      </Button>
      <Button
        variant="contained"
        onClick={() => {
          if (onSubmit) {
            onSubmit()
          } else if (onContinue) {
            onContinue()
          } else {
            setActiveStep(activeStep + 1)
          }
        }}
        disabled={!isContinueEnabled || isLoading}
      >
        {isLoading
          ? t('common.loading')
          : activeStep === DAMAGE_DURING_ROUTE_STEPS.length - 1
            ? t('damage_during_route.submit')
            : t('common.continue')}
      </Button>
    </Box>
  )
}
